import React from 'react';
import { LabelContainer, LabelOptionalTag } from './styles/label.styled';
export const Label = ({ text, required, reference, children, colorContext = 'on-light', disabled, }) => {
    return (React.createElement(LabelContainer, { htmlFor: reference, id: `${reference}-label`, "$colorContext": colorContext, "$disabled": disabled },
        text,
        !required && (React.createElement(React.Fragment, null,
            ' ',
            React.createElement(LabelOptionalTag, null, "(optioneel)"))),
        children));
};
//# sourceMappingURL=Label.js.map